import { Loader } from '@mantine/core'

import { LinkTypeDisplay } from 'src/graphql/types/trackingLinks'

import IndeedTrackingLink from './IndeedTrackingLink'
import TrackingLink from './TrackingLink'

interface JobListingTrackingLinksProps {
  trackingLinks: any[]
  trackingLinksLoading: boolean
  isEditMode: boolean
  jobListingId: string
  onDeleteLink: (linkId: string) => void
  onUpdateLinkName: (trackingLinkId: string, linkName: string) => void
  allEmployeeOptions: {
    employeeId: string
    label: string
    status?: string | null
  }[]
  jobDescription?: string | null
  jobEmploymentType?: string | null
  jobPayMin?: number | null
  jobPayUnit?: string | null
}

const JobListingTrackingLinks = ({
  trackingLinks,
  trackingLinksLoading,
  isEditMode,
  jobListingId,
  onDeleteLink,
  onUpdateLinkName,
  allEmployeeOptions,
  jobDescription,
  jobEmploymentType,
  jobPayMin,
  jobPayUnit,
}: JobListingTrackingLinksProps) => {
  const handleDeleteModal = (link) => {
    onDeleteLink(link)
  }

  return (
    <div className="flex max-h-[600px] flex-col gap-2 overflow-y-auto">
      {trackingLinksLoading ? (
        <div className="flex items-center justify-center">
          <Loader size={'xs'} color="gray" />
        </div>
      ) : (
        [...trackingLinks]
          .sort((a, b) => {
            const typeA = LinkTypeDisplay[a.linkType] || a.linkType
            const typeB = LinkTypeDisplay[b.linkType] || b.linkType

            // Primary sort: by type
            const typeComparison = typeA.localeCompare(typeB)
            if (typeComparison !== 0) {
              return typeComparison
            }

            // Secondary sort: by link name (if available)
            const nameA = a.linkName?.trim() || ''
            const nameB = b.linkName?.trim() || ''
            return nameA.localeCompare(nameB)
          })
          .map((link) =>
            link.linkType === 'INDEED' ? (
              <IndeedTrackingLink
                link={link}
                key={link.trackingLinkId}
                jobListingId={jobListingId}
                handleDeleteModal={handleDeleteModal}
                showDeleteButton={isEditMode}
                isEditMode={isEditMode}
                onUpdateLinkName={onUpdateLinkName}
                allEmployeeOptions={allEmployeeOptions}
                jobDescription={jobDescription}
                jobEmploymentType={jobEmploymentType}
                jobPayMin={jobPayMin}
                jobPayUnit={jobPayUnit}
              />
            ) : (
              <TrackingLink
                link={link}
                key={link.trackingLinkId}
                jobListingId={jobListingId}
                handleDeleteModal={handleDeleteModal}
                showDeleteButton={isEditMode}
                isEditMode={isEditMode}
                onUpdateLinkName={onUpdateLinkName}
                allEmployeeOptions={allEmployeeOptions}
              />
            )
          )
      )}
    </div>
  )
}

export default JobListingTrackingLinks
